import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'
import Paper from '@material-ui/core/Paper'
import TagFacesIcon from '@material-ui/icons/TagFaces'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import DoneIcon from '@material-ui/icons/Done'
import { filters } from './filters'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: '2em',
    margin: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  }
}))

interface Props {
  handleChipsChange: () => void
  propchips: string[]
}

export const ChipsArray = ({ handleChipsChange, propchips }: Props) => {
  const classes = useStyles()
  const [chipData, setChipData] = useState(propchips)
  const [chipSelectionLevel, setChipSelectionLevel] = useState(0)
  const [chipSelectedGroup, setChipSelectedGroup] = useState(0)

  const handleDelete = chipToDelete => () => {
    // console.log(filters.reduce((a, b) => [...a, ...b.options], []))
    // console.log(filters.reduce((a, b) => [...a, ...b.options], []).filter(chip => chip.id !== chipToDelete.id))
    const chips = chipData.filter(chip => chip !== chipToDelete.id)
    const allChips = chips || []
    setChipData(allChips)
    handleChipsChange(allChips)
  }

  useEffect(() => {
    handleChipsChange(chipData)
  }, [])

  useEffect(() => {
    setChipData(propchips)
  }, [propchips])

  const chipSelection = filters.map(data => {
    const handleClick = () => {
      console.log(data.id, data.label)
      setChipSelectedGroup(data.id)
      setChipSelectionLevel(2)
    }

    return (
      <li key={data.id}>
        <Chip
          clickable
          label={data.label}
          deleteIcon={<ChevronRightIcon />}
          onDelete={handleClick}
          onClick={handleClick}
          className={classes.chip}
        />
      </li>
    )
  })

  const chipOptions = filters[chipSelectedGroup].options.map(data => {
    const handleClick = () => {
      console.log(data.id, data.label)
      // Replace the chip if same category
      const c = chipData.filter(c => c.split('')[0] !== data.id.split('')[0])
      const allChips = [...c, data.id]
      setChipData(allChips)
      handleChipsChange(allChips)
      setChipSelectionLevel(0)
    }

    return (
      <li key={data.id}>
        <Chip
          clickable
          label={data.label}
          deleteIcon={<DoneIcon />}
          onDelete={handleClick}
          onClick={handleClick}
          className={classes.chip}
        />
      </li>
    )
  })

  return (
    <>
      <Paper component='ul' className={classes.root}>
        {chipSelectionLevel === 1
          ? chipSelection
          : chipSelectionLevel === 2
          ? chipOptions
          : chipData.length > 0
          ? chipData.map(chipId => {
              const dataIds = [chipId.split('')[0], chipId.substring(1)]
              const data = {
                id: chipId,
                label: filters[dataIds[0]].options[dataIds[1]].label
              }
              let icon

              if (data.label === 'React') {
                icon = <TagFacesIcon />
              }

              return (
                <li key={data.id}>
                  <Chip
                    icon={icon}
                    label={data.label}
                    onDelete={
                      data.label === 'React' ? undefined : handleDelete(data)
                    }
                    className={classes.chip}
                  />
                </li>
              )
            })
          : ''}
        {chipSelectionLevel === 0 && (
          <li>
            <Chip
              color='primary'
              label='Ajouter un filtre'
              onClick={() => {
                setChipSelectionLevel(1)
              }}
              onDelete={() => {
                setChipSelectionLevel(1)
              }}
              className={classes.chip}
              deleteIcon={<AddCircleIcon />}
            />
          </li>
        )}
      </Paper>
    </>
  )
}
